<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='带教老师月度绩效考评' label2="未考评" url="/achievement/teach/scorerecordchecklist"></PageHead>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Search Form -->
        <div class="m-form m-form--label-align-right">
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">考核月份：</label>
              </div>
              <div class="m-form__control">
                <el-date-picker v-model="condition.cpidate" type="month" placeholder="考核月份" value-format="yyyy-MM">
                </el-date-picker>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">状态：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.cpistatus" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in cpistatusOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
          <SearchButton :url='searchUrl' ref="btnSearch"></SearchButton>
        </div>
        <!--end: Search Form -->
        <!--begin: Datatable -->
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <el-table v-loading="loading" :data="tableData" stripe style="width: 100%" size="medium">
            <el-table-column prop="ManageSecName" label="管理单元">
            </el-table-column>
            <el-table-column prop="CPIStatus" label="状态">
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  export default {
    name: 'TecNoPut',
    data() {
      return {
        condition: {
          username: '',
          rolelevel: '',
          secid: '',
          cpitype: '2',
          cpidate: '',
          cpistatus: '',
          token: '',
          pageSize: 10,
          currentPage: 1,
          recordCount: 0,
          firstSearch: true
        },
        tableData: null,
        searchUrl: this.$utils.Url.zpgl + '/api/APICPI/NoPutList',
        loading: true,
        secOptions: [],
        cpistatusOptions: [{
          value: '未考评',
          label: '未考评'
        }, {
          value: '考评未提交',
          label: '考评未提交'
        }, {
          value: '退回',
          label: '退回'
        }],
      }
    },
    methods: {
    },
    mounted: function() {
      this.condition.token = sessionStorage.getItem('token')
      this.condition.username = sessionStorage.getItem('username')
      this.condition.rolelevel = sessionStorage.getItem('rolelevel')
      this.condition.secid = sessionStorage.getItem('secid')
      var date = new Date()
      var year = date.getFullYear()
      console.log(date.getMonth())
      var month = date.getMonth() + 1
      if (month > 12) {
        year = year + 1
        month = 1
      }
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      this.condition.cpidate = year + '-' + month
      this.$refs.btnSearch.Search()
    }
  }
</script>

<style scoped="scoped">
  /deep/.el-input {
    width: 220px;
  }
</style>
